import _replace from "lodash/replace";
import _isString from "lodash/isString";
import _includes from "lodash/includes";
import _camelCase from "lodash/camelCase";
import ReactDOMServer from 'react-dom/server';
import { formatUri } from '@signavio/ui/core';
import i18n from '@signavio/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
export const protocols = 'https?|file|ftp';

// http://snipplr.com/view/19594/

/* eslint-disable no-return-assign, no-useless-escape */
const emailRegex = /^[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
/* eslint-enable no-return-assign, no-param-reassign */

// returns the, potentially corrected, URL str is a valid URL starting with a protocol part or www.
// otherwise returns false
export function validateUrl(str) {
  if (!formatUri(str) || isEmail(str)) {
    return false;
  }
  return str;
}
export function validateEmail(email) {
  if (!_isString(email)) {
    return false;
  }
  return emailRegex.test(email.trim());
}
export function isEmail(email) {
  return validateEmail(email);
}
export function parseMentions(str, props = {}) {
  return str.replace(
  // eslint-disable-next-line no-useless-escape
  /(@\[(.*?)\]\((invitee|user|shortcut|email)\:.*?\))/gi, function (_, __, text) {
    return ReactDOMServer.renderToStaticMarkup(/*#__PURE__*/_jsx("span", {
      ...props,
      children: text
    }));
  });
}
export function keyify(str, usedKeys = []) {
  let key = _camelCase(_replace(str, /([^\w\s])/g, ' ')).trim();
  if (key.length === 0) {
    key = i18n('unnamed');
  }
  if (/^\d.*/.test(key)) {
    // key must not start with a digit
    key = 'f' + key; // simply prepend a 'f'
  }
  if (!usedKeys) usedKeys = [];
  if (_includes(usedKeys, key)) {
    let index = 2;
    while (_includes(usedKeys, key + index)) {
      index++;
    }
    return key + index;
  }
  return key;
}
export function preview(str, numberOfChars) {
  // used
  let result = str.trim();
  if (result.indexOf('\n') > 0) {
    result = result.substring(0, result.indexOf('\n'));
  }
  if (result.length > numberOfChars) {
    const i = result.lastIndexOf(' ', numberOfChars);
    if (i > 0) {
      result = result.substring(0, i);
    } else {
      result = result.substring(0, numberOfChars);
    }
  }
  return result;
}

/**
 * Returns a string with at least 64-bits of randomness, e.g. sn1s7vb4gcic.
 *
 * Doesn't trust Javascript's random function entirely. Uses a combination of
 * random and current timestamp, and then encodes the string in base-36 to
 * make it shorter.
 */
export function randomString() {
  const x = 2147483648;
  const timestamp = window.performance && window.performance.now ? window.performance.now() : new Date().getTime();
  return Math.floor(Math.random() * x).toString(36) + Math.abs(Math.floor(Math.random() * x) ^ timestamp).toString(36);
}
export function cleanupMarkdownLink(markdown) {
  return markdown.replace(/\[.*<span>.*<\/span>.*]/gi, match => match.replace(/<span>/gi, '').replace(/<\/span>/gi, ''));
}